// extracted by mini-css-extract-plugin
export default {"user_cartoons_container":"UserCartoons_user_cartoons_container__FkA8C","gap_50":"UserCartoons_gap_50__s14i9","gap_20":"UserCartoons_gap_20__bd5Ja"};